<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Pupillogram</v-toolbar-title>
        </v-toolbar>
        <fullscreen class="wrapper" ref="fullscreen" @change="fullscreenChange" background="#FFFFFF">
            <LineChart :styles="chartStyles" :chart-data="chartDataLocal.data" :options="chartDataLocal.options"/>
            <button type="button" class="btn btn-default btn-map-fullscreen" @click="toggleFullScreen">
                <i class="mdi" :class="[fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen']"/>
            </button>
        </fullscreen>
    </div>
</template>

<script>
    import LineChart from './line-chart.js'
    import Fullscreen from 'vue-fullscreen/src/component.vue'
    import {mapActions, mapMutations, mapState} from 'vuex';

    export default
    {
        name: 'pupillogram-graph',
        components:
        {
            LineChart,
            Fullscreen
        },
        data: function ()
        {
            return {
                chartDataLocal: {},
                fullscreen : false,
                localTest2: null,
                ucl: [],
                lcl: []
            }
        },
        props:
        {
            eyeChoice: Number(0),
            tests: Array,
            test1: {},
            test2: {}
        },
        computed:
        {
            ...mapState('tests',
            {
                pupillogramNormalCurveBounds: state => state.pupillogramNormalCurveBounds
            }),
            chartStyles()
            {
                return {
                    height: '100%',
                    width: '100%'
                }
            }
        },
        watch:
        {
            eyeChoice()
            {
                this.localTest2 = null;
                this.chartDataCommon()
            },
            test1()
            {
                this.localTest2 = null;
                this.chartDataCommon()
            }
        },
        async mounted()
        {
            await this.loadPupillogramNormalCurveBounds();
            this.chartDataCommon()
        },
        methods:
        {
            ...mapActions('tests', ['GET_PUPILLOGRAM_NORMAL_CURVE_BOUNDS']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            recentBaselineTestForEye(testToCompare)
            {
                for (const test of this.tests)
                {
                    if ('PLR' === testToCompare.operationalMode)
                    {
                        // Constrict
                        if (0 === testToCompare.resultTypeIndex)
                        {
                            let index = 0
                            for (const visit of test.eyes[0].timeSeries)
                            {
                                if (!this.pupillogramNormalCurveBounds)
                                {
                                    break
                                }
                                this.ucl.push(this.pupillogramNormalCurveBounds.data[index][0]);
                                this.lcl.push(this.pupillogramNormalCurveBounds.data[index][1]);
                                index++;
                            }
                        }

                        const eyeIndex = 2 === test.eyes.length ? testToCompare.rightEye ? 0 : 1 : 0;
                        if (test.eyes[eyeIndex].operationalMode === testToCompare.operationalMode && test.visitDateAsDate <= new Date(testToCompare.visitDate) && 'Yes' === test.eyes[eyeIndex].baseline && 0 === test.eyes[eyeIndex].errCode)
                        {
                            if (2 === test.eyes.length || (1 === test.eyes.length && testToCompare.rightEye === test.eyes[0].rightEye))
                            {
                                if (testToCompare.resultTypeIndex === test.eyes[eyeIndex].resultTypeIndex)
                                {
                                    // Full Spectrum w/Flash
                                    if (1 === testToCompare.resultTypeIndex && testToCompare.metaData.videoDuration === test.eyes[eyeIndex].metaData.videoDuration && testToCompare.metaData.illuminationDelay === test.eyes[eyeIndex].metaData.illuminationDelay)
                                    {
                                        return test.eyes[eyeIndex]
                                    }
                                    // Full Spectrum w/Flash + Ambient
                                    if (4 === testToCompare.resultTypeIndex && testToCompare.metaData.videoDuration === test.eyes[eyeIndex].metaData.videoDuration && testToCompare.metaData.ambientLevel === test.eyes[eyeIndex].metaData.ambientLevel && testToCompare.metaData.illuminationDelay === test.eyes[eyeIndex].metaData.illuminationDelay)
                                    {
                                        return test.eyes[eyeIndex]
                                    }
                                    // Constrict
                                    if (0 === testToCompare.resultTypeIndex && testToCompare.metaData.torchLevel === test.eyes[eyeIndex].metaData.torchLevel && testToCompare.metaData.videoDuration === test.eyes[eyeIndex].metaData.videoDuration && testToCompare.metaData.illuminationDelay === test.eyes[eyeIndex].metaData.illuminationDelay)
                                    {
                                        return test.eyes[eyeIndex]
                                    }
                                    // Full Spectrum w/Pulse
                                    if (2 === testToCompare.resultTypeIndex && testToCompare.metaData.torchLevel === test.eyes[eyeIndex].metaData.torchLevel && testToCompare.metaData.torchDuration === test.eyes[eyeIndex].metaData.torchDuration && testToCompare.metaData.videoDuration === test.eyes[eyeIndex].metaData.videoDuration && testToCompare.metaData.illuminationDelay === test.eyes[eyeIndex].metaData.illuminationDelay)
                                    {
                                        return test.eyes[eyeIndex]
                                    }
                                    // Full Spectrum w/Pulse + Ambient
                                    if (5 === testToCompare.resultTypeIndex && testToCompare.metaData.torchLevel === test.eyes[eyeIndex].metaData.torchLevel && testToCompare.metaData.torchDuration === test.eyes[eyeIndex].metaData.torchDuration && testToCompare.metaData.videoDuration === test.eyes[eyeIndex].metaData.videoDuration && testToCompare.metaData.ambientLevel === test.eyes[eyeIndex].metaData.ambientLevel && testToCompare.metaData.illuminationDelay === test.eyes[eyeIndex].metaData.illuminationDelay)
                                    {
                                        return test.eyes[eyeIndex]
                                    }
                                }
                            }
                        }
                    }
                    else //NPC
                    {
                        if (test.eyes[0].operationalMode === testToCompare.operationalMode && test.eyes[0].visitDate <= testToCompare.visitDate && test.eyes[0].baseline && 0 === test.eyes[0].errCode)
                        {
                            return test
                        }
                    }
                }
                return null
            },
            toggleFullScreen()
            {
                this.$refs['fullscreen'].toggle()
            },
            fullscreenChange (fullscreen)
            {
                this.fullscreen = fullscreen
            },
            chartDataCommon()
            {
                let xData = [];
                let yData1 = [];
                let yData2 = [];
                let baselineShown = 'Yes' === this.test1.baseline;

                let chartDataLength = 0;
                if (2 === this.eyeChoice)
                {
                    this.localTest2 = this.test2;
                    chartDataLength = this.localTest2 && this.localTest2.timeSeries.length > this.test1.timeSeries.length ? this.localTest2.timeSeries.length : this.test1.timeSeries.length
                }
                else
                {
                    // If not a baseline and there is just one eye being tested, try and get a baseline to show
                    if ('No' === this.test1.baseline)
                    {
                        this.localTest2 = this.recentBaselineTestForEye(this.test1);
                        if (this.localTest2)
                        {
                            baselineShown = true
                        }
                    }
                    chartDataLength = this.test1.timeSeries.length
                }
                for (let index = 0; index < chartDataLength; ++index)
                {
                    // Do not include any values that are 0 which indicates a blink
                    // This should only happen at the start or end, the middle should have interpolated values
                    if (this.test1.timeSeries.length > index && this.test1.timeSeries[index] !== 0)
                    {
                        yData1.push(+(Math.round(this.test1.timeSeries[index] + 'e+3') + 'e-3'))
                    }
                    else // Show 0 data as empty
                    {
                        yData1.push(null)
                    }
                    if (this.localTest2 && this.localTest2.timeSeries.length > index && this.localTest2.timeSeries[index] !== 0)
                    {
                        yData2.push(+(Math.round(this.localTest2.timeSeries[index] + 'e+3') + 'e-3'))
                    }
                    else // Show 0 data as empty
                    {
                        yData2.push(null)
                    }
                    xData.push((index * 0.033333333333).toFixed(2))
                }
                this.chartDataLocal =
                {
                    type: 'line',
                    data:
                    {
                        labels: xData,
                        datasets:
                        [
                            {
                                label: `${2 === this.eyeChoice ? 'Right Eye' : 'Right' === this.test1.eyeLocation ? 'Right Eye' : 'Left Eye'}`,
                                data: yData1,
                                backgroundColor: 2 === this.eyeChoice ? this.test1.reflexScoreColor : 'Yes' === this.test1.baseline ? '#E65100' : this.test1.reflexScoreColor,
                                borderColor: 2 === this.eyeChoice ? this.test1.reflexScoreColor : 'Yes' === this.test1.baseline ? '#E65100' : this.test1.reflexScoreColor,
                                fill: false,
                                borderWidth: 1
                            }
                        ]
                    },
                    options:
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales:
                        {
                            yAxes:
                            [
                                {
                                    ticks:
                                    {
                                        beginAtZero: false
                                    },
                                    scaleLabel:
                                    {
                                        display: true,
                                        labelString: 'Pupil Diameter (mm)'
                                    }
                                }
                            ],
                            xAxes:
                            [
                                {
                                    ticks:
                                    {
                                        maxTicksLimit: 30
                                    },
                                    scaleLabel:
                                    {
                                        display: true,
                                        labelString: 'Time in Seconds'
                                    }
                                }
                            ]
                        }
                    }
                };
                if (this.localTest2 && (baselineShown || 2 === this.eyeChoice))
                {
                    this.chartDataLocal.data.datasets.splice(1, 0,
                    {
                        label: `${baselineShown && 'Yes' === this.test1.baseline ? 'Left Eye' : baselineShown ? 'Baseline' : 'Left Eye'}`,
                        data: yData2,
                        backgroundColor: this.localTest2.reflexScoreColor,
                        borderColor: this.localTest2.reflexScoreColor === this.test1.reflexScoreColor ?'#E0E0E0' : this.localTest2.reflexScoreColor,
                        fill: false,
                        borderWidth: 1
                    });
                }
                // If we should show the normal curve bounds
                if (this.ucl.length > 0)
                {
                    this.chartDataLocal.data.datasets.push(
                        {
                            label: 'UCL',
                            data: this.ucl,
                            pointRadius: 0,
                            borderColor: '#75757520',
                            backgroundColor: '#75757520',
                            borderWidth: 2,
                            fill: '+1'
                        });
                    this.chartDataLocal.data.datasets.push(
                        {
                            label: 'LCL',
                            data: this.lcl,
                            pointRadius: 0,
                            borderColor: '#75757520',
                            backgroundColor: '#75757520',
                            borderWidth: 2,
                            fill: false
                        });
                }
            },
            async loadPupillogramNormalCurveBounds()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.GET_PUPILLOGRAM_NORMAL_CURVE_BOUNDS()
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            }
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .wrapper
    {
        position: relative;
        height: 400px;

        .btn-map-fullscreen
        {
            position: absolute;
            right: 1px;
            top: 1px;
            width: 36px;
            height: 36px;
            padding: 0;
            font-size: 36px;
            line-height: 36px;
            text-align: center;
            outline: none;
        }

        &.fullscreen
        {
            .btn-map-fullscreen
            {
                right: 1px;
                top: 1px;
            }
        }
    }
</style>